<template>
    <div class="mb-10 flex items-center">
        <div class="text-md uppercase mr-4">
            {{ t.filter }}:
        </div>
        <Dropdown v-model="selected" :options="options" optionLabel="label" optionValue="value" :placeholder="t.all" :showClear="true" />
    </div>
    <swiper
        :slides-per-view="1"
        :space-between="16"
        navigation
        :breakpoints="breakpoints"
        class="news-slider"
        v-if="this.filteredData.length > 0"
    >
        <template v-for="(item, index) in filteredData" :key="index">
            <swiper-slide>               
                <news-item :item="item"></news-item>
            </swiper-slide>        
        </template>
    </swiper>
    <div v-else class="my-20">
        <div class="text-2xl text-center font-light">
            {{ t.noResults }}
        </div>
    </div>
</template>

<script>
import ContentApi from '../../mixins/ContentApi.vue'
import FilterByTag from '../../mixins/FilterByTag.vue'

import SwiperCore, { Navigation, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import Dropdown from 'primevue/dropdown/sfc';

import NewsItem from './NewsItem.vue'

SwiperCore.use([Navigation, Lazy])

export default {

    props: {
        't': Object,
        'site': Object
    },

    components: {
        NewsItem,
        Swiper,
        SwiperSlide,
        Dropdown
    },

    mixins: [ContentApi, FilterByTag],

    data() {
        return {
            data: '',
            filterProperty: 'news_category',
            selected: null,
            url: '/api/collections/news/entries?sort=-date&filter[site]='+this.site.handle,
            breakpoints: {
                720: {
                  slidesPerView: 2,
                  spaceBetween: 16
                },
                1280: {
                  slidesPerView: 3,
                  spaceBetween: 24
                }
            }
        }
    },

};
</script>